import { Close } from 'generated/icons';
import classNames from 'classnames';
import React from 'react';
import Text from '../Text';
import UpgradeIcon from './icons/UpgradeIcon';

export type StepBadgeStatus = 'pending' | 'active' | 'completed' | 'failed';

export default function StepBadge({ status, number }: { status: StepBadgeStatus; number: number }) {
  return (
    <span
      aria-hidden="true"
      className={classNames('flex h-8 w-8 shrink-0 items-center justify-center rounded-full', {
        'bg-control-primary text-white': status === 'active',
        'bg-control-secondary text-muted': status === 'pending',
        'bg-green-light-9 dark:bg-green-dark-9 text-white': status === 'completed',
        'bg-alert-warning text-default': status === 'failed',
      })}
    >
      {status === 'completed' ? (
        <UpgradeIcon name="check" />
      ) : status === 'failed' ? (
        <Close className="h-4 w-4" />
      ) : (
        <Text variant="base" className="text-xs !text-current">
          {number}
        </Text>
      )}
    </span>
  );
}
